module.exports = __webpack_public_path__ + "src/assets/img/cmd-go-service-start.941de970.svg";